export const formatTextDefault = (key: string, value: string) => `${value}・${key}`;
